export default "__VITE_ASSET__BkgaMcpM__"